import React from 'react';
import { CHEAT_BORDER, CHEAT_LABEL_TEXT } from '../../constants/cheatStyles';

const DEFAULT_LABEL = 'CHEAT';

interface Props {
  /** Stack the buttons vertically instead of side by side. */
  vertical?: boolean;
  label?: string;
  children: React.ReactNode;
}

/**
 * Amber dashed frame with a "CHEAT" caption. Wraps clusters of cheat buttons whose own
 * colours carry meaning (green = force a win, red = force a loss) so they still read as
 * cheats rather than as ordinary gameplay controls.
 */
export const CheatGroup: React.FC<Props> = ({ vertical = false, label = DEFAULT_LABEL, children }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    padding: '3px 6px 4px',
    border: `1px dashed ${CHEAT_BORDER}`,
    borderRadius: 8,
  }}>
    <span style={{
      color: CHEAT_LABEL_TEXT,
      fontFamily: 'monospace',
      fontSize: 9,
      letterSpacing: 1,
      lineHeight: 1,
    }}>
      {label}
    </span>
    <div style={{
      display: 'flex',
      flexDirection: vertical ? 'column' : 'row',
      gap: 4,
      alignItems: 'stretch',
      flex: 1,
    }}>
      {children}
    </div>
  </div>
);
